module.exports = __webpack_public_path__ + "static/media/wide.eabdc493.jpg";